<script setup>
// import { defineComponent, reactive, ref } from 'vue'

const NORMAL_WIDTH = 1400;
const NORMAL_HEIGHT = 830;
const GUTTERS = 0;

const props = defineProps({
  hallCathegory: {
    type: String,
    default: () => "",
  },
  hall: { type: Object, required: true },
  placeComponent: { type: Object, required: true },
  popupComponent: { type: [Object, null], default: null },
  tickets: { type: Array, default: () => [] },
  cart: { type: Array, default: () => [] },
});

const emit = defineEmits(["addTicketToCart", "removeTicketFromCart"]);

function onAddTicketToCart(e) {
  emit("addTicketToCart", e);
}

function onRemoveTicketFromCart(e) {
  emit("removeTicketFromCart", e);
}

const hall = reactive(props.hall);
const rowKeys = reactive(Object.keys(hall));

const getPlacesKeys = (places) => {
  return Object.keys(places)
    .sort((a, b) => {
      a = Number(a);
      b = Number(a);
      return a - b;
    })
    .reverse();
};

const zoom = ref(1);

const maxHeight = ref("-webkit-fill-available");

const onWindowResize = () => {
  const width = window.innerWidth;
  if (width < NORMAL_WIDTH + 2 * GUTTERS) {
    zoom.value = width / (GUTTERS * 2 + NORMAL_WIDTH);
    maxHeight.value = `${zoom.value * NORMAL_HEIGHT + 25}px`;
  } else {
    zoom.value = 1;
    maxHeight.value = `${zoom.value * NORMAL_HEIGHT + 25}px`;
  }
};
onMounted(() => {
  window.addEventListener("resize", onWindowResize);
  onWindowResize();
});

onUnmounted(() => {
  window.removeEventListener("resize", onWindowResize);
});
</script>

<template>
  <div
    class="max-w-full w-full relative flex flex-row justify-center"
    :style="{ height: `${maxHeight}` }"
    ref="wrapper"
  >
    <div class="origin-top flex-auto" :style="`transform: scale(${zoom});`">
      <div class="mx-auto" style="width: 1024px !important">
        <div class="round-hall flex flex-col-reverse space-y-3 space-y-reverse">
          <div class="round-hall__row" v-for="rowKey in rowKeys" :key="rowKey">
            <component
              v-for="placeKey in getPlacesKeys(hall[rowKey])"
              :key="`${rowKey} ${placeKey}`"
              :is="placeComponent"
              :popup-component="popupComponent"
              :row="rowKey"
              :place-key="placeKey"
              :place="hall[rowKey][placeKey]"
              :tickets="tickets"
              :cart="cart"
              :hallCathegory="hallCathegory"
              @add-ticket-to-cart="onAddTicketToCart"
              @remove-ticket-from-cart="onRemoveTicketFromCart"
            />
          </div>
          <!-- <Row class="round-hall__row" v-for="item in roundHallKeys" :key="item" :row="item" :places="hall[item]" /> -->
        </div>
        <div class="footbuy">
          <p>сцена</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.round-hall {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  margin: auto;

  &__row {
    position: relative;
    width: 100%;
  }
}

.footbuy {
  position: absolute;
  left: calc(50% - 300px);
  top: 0px;
  right: 0px;
  margin-top: 0px;
  border-bottom-left-radius: 100%;
  border-bottom-right-radius: 100%;
  width: 600px;
  border-width: 600px 0px 0px;
  border-style: solid;
  border-color: gray transparent transparent;
  border-image: initial;
  text-align: center;

  p {
    margin-top: -240px;
    font-size: 40px;
    text-transform: uppercase;
    color: white;
  }
}
</style>
